import { Command } from './Command';
import { applyLayerOrder } from '../constants/layerDefinitions';

/**
 * ReorderObjectCommand - Changes the z-order of objects within a layer
 *
 * Used when the user drags objects in the LayerPanel to reorder them.
 * Only affects objects within the same layer (cross-layer reordering is not supported).
 *
 * @example
 * const changes = layerObjects.map((obj, newIndex) => ({
 *   object: obj,
 *   oldZIndex: obj.data?.zIndexWithinLayer ?? 0,
 *   newZIndex: newIndex,
 * }));
 * commandStack.execute(new ReorderObjectCommand(canvas, changes));
 */
export class ReorderObjectCommand extends Command {
  /**
   * @param {fabric.Canvas} canvas
   * @param {Array<{object: Object, oldZIndex: number, newZIndex: number}>} changes
   */
  constructor(canvas, changes) {
    super();
    this.canvas = canvas;
    this.changes = changes;
  }

  execute() {
    this.changes.forEach(({ object, newZIndex }) => {
      if (!object.data) object.data = {};
      object.data.zIndexWithinLayer = newZIndex;
    });
    applyLayerOrder(this.canvas);
    this.canvas.renderAll();
    this.canvas.fire('layer:reordered');
  }

  undo() {
    this.changes.forEach(({ object, oldZIndex }) => {
      if (!object.data) object.data = {};
      object.data.zIndexWithinLayer = oldZIndex;
    });
    applyLayerOrder(this.canvas);
    this.canvas.renderAll();
    this.canvas.fire('layer:reordered');
  }

  getDescription() {
    return 'Reihenfolge ändern';
  }
}
